import React from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import config from 'config';
import { externalWindow } from 'utils';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function CustomGoogleMap({ lat, lng }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: config.googleAPIKey,
  });

  const openInNewTab = () => {
    const url = `${config.googleMapsUrl}/?q=${lat},${lng}`;
    externalWindow.launchNewTab(url, { features: 'noopener, noreferrer' });
  };

  return isLoaded ? (
    <GoogleMap
      clickableIcons={false}
      mapContainerClassName={classes.container}
      onClick={openInNewTab}
      options={{
        center: { lat, lng },
        zoom: 17,
        fullscreenControl: false,
        disableDefaultUI: true,
        disableDoubleClickZoom: true,
        draggable: false,
        draggableCursor: 'pointer',
      }}
    >
      <Marker position={{ lat, lng }} />
    </GoogleMap>
  ) : (
    <span>{t('loading')}</span>
  );
}

CustomGoogleMap.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
};

export default CustomGoogleMap;
